export enum MaintenancePriority {
  Low ='Low',
  Medium = 'Medium',
  High = 'High',
  Urgent = 'Urgent'
}